import { IMaintenanceBlankSchema } from '@/pages/Processes/Maintenance/maintenance.types.ts'
import useMaintenanceBlankSchema from '@/pages/Processes/Maintenance/hooks/useMaintenanceBlankSchema.ts'
import useStateWithChange from '@/shared/hooks/useStateWithChange.ts'
import useHttpLoader from '@/shared/hooks/useHttpLoader.ts'
import maintenanceApi from '@/pages/Processes/Maintenance/maintenance.api.ts'
import maintenanceEvents from '@/pages/Processes/Maintenance/events/maintenance.events.ts'
import useNestedArrayChangeCallbacks from '@/shared/hooks/useNestedArrayChangeCallbacks.ts'
import maintenanceBlanksUtils from '@/pages/Processes/Maintenance/MaintenanceBlanks/maintenanceBlanks.utils.ts'
import SeparateLine from '@/shared/Forms/SeparateLine'
import MaintenanceBlankForm from '@/pages/Processes/Maintenance/MaintenanceBlanks/components/MaintenanceBlankForm'
import Button from '@/shared/Buttons/Button'

interface IProps {
  onCancel: () => void
  blankId: IMaintenanceBlankSchema['id']
}

const EditMaintenanceBlankSidePageContent = (props: IProps) => {
  const { wait, loading } = useHttpLoader()

  const blank = useMaintenanceBlankSchema(props.blankId)
  const [draft, setDraft, handleChange] = useStateWithChange(blank)

  const {
    handleCreateNewElement: handleFieldCreate,
    handleElementUpdate: handleFieldUpdate,
    handleElementDelete: handleFieldDelete,
  } = useNestedArrayChangeCallbacks({
    sourceObjectSetter: setDraft,
    nestedArrayKey: 'fields',
    newEntityGenerator: () => maintenanceBlanksUtils.generateBlankFieldDTO(draft.fields.length),
  })

  const handleSave = () => {
    wait(maintenanceApi.updateBlankSchema(props.blankId, draft), (resp) => {
      if (resp.status === 'success') {
        maintenanceEvents.schemaUpdated(resp.body)
        props.onCancel()
      }
    })
  }

  return (
    <div className="flex-lines gap16" style={{ height: '100%' }}>
      <h2 className="text-heading-4">Редактирование бланка ТО</h2>
      <div style={{ paddingRight: '20px' }}>
        <SeparateLine />
      </div>
      <div className="flex-lines gap16" style={{ minHeight: 0, overflow: 'auto', paddingRight: '20px' }}>
        <MaintenanceBlankForm
          blank={draft}
          onChange={handleChange}
          onCreateField={handleFieldCreate}
          onDeleteField={handleFieldDelete}
          onUpdateField={handleFieldUpdate}
        />
      </div>
      <div style={{ marginTop: 'auto', paddingRight: '20px' }}>
        <SeparateLine />
      </div>
      <div className="inline-flex-gap gap8">
        <Button size="default" type="primary" text="Сохранить" onClick={handleSave} loading={loading} />
        <Button size="default" type="default" text="Отменить" onClick={props.onCancel} disabled={loading} />
      </div>
    </div>
  )
}

export default EditMaintenanceBlankSidePageContent
